import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, Container } from '@teko/ds-desktop';

const TOPBAR_HEIGHT = 42;
const Topbar = ({ rightMenu = [], leftMenu = [], }) => {
    return (jsx(Wrapper, { children: jsxs(StyledContainer, { children: [jsx(MenuWrapper, { children: leftMenu.map((item) => item) }, void 0), jsx(MenuWrapper, { children: rightMenu.map((item) => item) }, void 0)] }, void 0) }, void 0));
};
const Wrapper = styled.div(({ theme }) => `
  @media print {
    display: none;
  }
  background-color: ${theme.colors.primary500};
  height: ${TOPBAR_HEIGHT}px;
`);
const StyledContainer = styled(Container) `
  display: flex;
  justify-content: space-between;
`;
const MenuWrapper = styled.div `
  display: flex;
  .button-text {
    font-weight: 500;
  }
`;

export { TOPBAR_HEIGHT, Topbar };
